export const HttpStatus = {
    FORBIDDEN:            403,
    CONFLICT:             409,
    SERVICE_UNAVAILABLE:  503,
} as const;
